import request from 'superagent';
import Promise from 'bluebird';

import urlUtils from 'utils/urlUtils';
import config from 'src/config';
import errorUtils from 'utils/errorUtils';
import authHelper from 'api/auth/helper';

const REQUEST_TYPES = {
  get: 'get',
  post: 'post',
  put: 'put',
  patch: 'patch',
  delete: 'delete'
};

function get(path, query, options) {
  return makeRequest('get', path, query, null, options);
}

function post(path, body, options) {
  return makeRequest('post', path, null, body, options);
}

function put(path, body, options) {
  return makeRequest('put', path, null, body, options);
}

function patch(path, body, options) {
  return makeRequest('patch', path, null, body, options);
}

function del(path, body, options) {
  return makeRequest('delete', path, null, body, options);
}

function makeRequest(type, path, query, body, options) {
  if (!type) throw new Error('type');
  if (!path) throw new Error('path');
  if (!REQUEST_TYPES[type]) throw new Error(`${type} is not a valid request type`);

  options = options || {};

  const fullUrl = urlUtils.combinePaths(config.TABLELIST_API_BASE_URL, path);

  const requestPromise = request[type](fullUrl)
    .set('Accept', 'application/json')
    .set('api-key', config.TL_API_KEY);

  if (query) requestPromise.query(query);
  if (body) requestPromise.send(body);
  if (options.headers) {
    Object.keys(options.headers).forEach(key => {
      requestPromise.set(key, options.headers[key]);
    });
  }

  if (authHelper.getAuthToken()) {
    requestPromise.set('x-access-token', authHelper.getAuthToken());
  } else {
    requestPromise.set('x-prospect-token', authHelper.getProspectToken());
  }

  return requestPromise
    .then(response => response.body)
    .catch(err => handleApiError(err));
}

function handleApiError(err) {
  const response = err.response;

  if (!response) {
    return Promise.reject(err);
  }

  // if (response.status === 401) {
  //   //TODO: need to do more here - right now we're just removing their auth token
  //   //we need the background script to hide the extension and show the alert again and redirect
  //   store.dispatch('logout');
  // }

  const errorMessage = errorUtils.getErrorFromApiResponse(response.body);

  return Promise.reject(new Error(errorMessage));
}

export default {
  get,
  post,
  put,
  patch,
  del
};



// WEBPACK FOOTER //
// ./src/api/tablelistApi.js